<template>
  <div class="service-plan">

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="서비스 플랜 설정 조회"
      desc="서비스 플랜 설정의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end">
      <button @click="routerPush(getPath('launchpack/service_plan/create'))"
              class="button is-primary" style="width: auto">플랜 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 :table_width="1650"
                 @selPageLength="selPageLength">
      <div slot="usage" slot-scope="props">
        <div v-for="(kor_name, key, p_idx) in service_plan" :key="`p-${p_idx}`">
          {{ kor_name }}: {{ props.item.usage[key] }}
        </div>
      </div>
      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger"
                @click.stop.prevent="clickItem(props.item,'delete')">삭제</button>
      </div>

    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'ServicePlanList',
    mixins: [
      ListMixin
    ],
    data() {
      return {
        service_plan: {
          user: '회원가입수',
          front: '프론트 서비스 제공 범위',
          partner: '파트너등록수',
          product: '상품 등록수',
          category: '상품 카테고리수',
          template: '블록템플릿 무제한 이용권',
          admin_account: '관리자 계정 갯수',
        }
      }
    },
    created() {
      this.init();
    },

    methods: {
      init () {
        this.initializing('launchpack_service_plan', 'launchpack/service_plan');
      },
      getDataFromServer() {
        this.getData();
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 20px; height: 20px; background-size: cover;' +
          ' background-position: center; margin-right: 8px';
      },
      clickItem(item, kind) {
        if ( kind === 'update' ) {
          this.$router.push(this.getPath('launchpack/service_plan/create?id='+item.id));
        }
        else if ( kind === 'delete' ) {
          let value = {
            id: item.id,
            url: 'launchpack/service_plan/',
            title: '플랜 설정을 삭제하시겠습니까?'
          }

          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .service-plan .admin-table td > div
    -webkit-line-clamp unset
</style>
